module.exports = __webpack_public_path__ + "img/sending_7.5daeeb8e.png";